export const colorValues = [
  "white",
  "black",
  "gray",
  "lightGray",
  "brown",
  "lightBrown",
  "orange",
  "lightOrange",
  "yellow",
  "lightYellow",
  "green",
  "lightGreen",
  "blue",
  "lightBlue",
  "purple",
  "lightPurple",
  "magenta",
  "lightMagenta",
  "red",
  "lightRed",
] as const;

export const lightColorValues = [
  "white",
  "lightGray",
  "lightBrown",
  "lightOrange",
  "lightYellow",
  "lightGreen",
  "lightBlue",
  "lightPurple",
  "lightMagenta",
  "lightRed",
] as const;

export const darkColorValues = [
  "black",
  "gray",
  "brown",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "magenta",
  "red",
] as const;

export const colorRGBValuesTriplet: {
  [key: string]: readonly [number, number, number];
} = {
  white: [255, 255, 255],
  black: [55, 53, 48],
  gray: [120, 119, 116],
  lightGray: [241, 241, 239],
  brown: [151, 109, 87],
  lightBrown: [243, 238, 238],
  orange: [204, 120, 47],
  lightOrange: [248, 236, 223],
  yellow: [194, 147, 67],
  lightYellow: [250, 243, 221],
  green: [84, 129, 100],
  lightGreen: [238, 243, 237],
  blue: [72, 124, 165],
  lightBlue: [233, 243, 247],
  purple: [138, 103, 171],
  lightPurple: [246, 243, 248],
  magenta: [179, 84, 136],
  lightMagenta: [249, 242, 245],
  red: [196, 85, 77],
  lightRed: [250, 236, 236],
};

export type Color = (typeof colorValues)[number];

export type LightColor = (typeof lightColorValues)[number];

export type DarkColor = (typeof darkColorValues)[number];
